module.exports = __webpack_public_path__ + "img/lmv_fr-BE_old.7538bfc4.svg";